import httpService from './httpService';
import { resetPasswordLinkUrl } from '../constants/apiEndPoints';

export function forgotPasswordAPI(email) {
    const data = { login: email };
    return httpService.post(resetPasswordLinkUrl, data);
}
